module.exports = __webpack_public_path__ + "e2dc03b93ea7f31762a94c62e5775208.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/en/stingray_classica_mobile.jpg
// module id = 857
// module chunks = 0